var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('el-carousel',{attrs:{"interval":4000,"height":"600px"}},_vm._l((_vm.swiper),function(item){return _c('el-carousel-item',[_c('img',{attrs:{"src":item.img,"alt":""}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }